<template>
  <div
    class="content purchase_page scan"
    :style="{
      backgroundImage: 'url(' + require('../assets/img/wof_back.png') + ')',
    }"
  >
    <main>
      <div class="title_holder">
        <!-- <steps :step='step' :steps='steps'></steps> -->
        <h4 style="margin-top:1em">Let's make that mouthguard yours</h4>
        <h1>FILL OUT BELOW</h1>
      </div>

      <transition name="fade">
        <div v-if="superrb">
          <info
            v-if="step == 1"
            @assignUserInfo="assignUserInfo"
            :type="superrb.product_type"
            :subscription_data="$route.params.subscription"
          ></info>
        </div>
      </transition>
      <transition name="fade">
        <cart-popup :userInfo="userInfo" v-if="step == 2" :showSuccess="showSuccess"></cart-popup>
      </transition>
    </main>
  </div>
</template>

<script>
var moment = require("moment");
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const sendCart = fb.default.functions.httpsCallable("sendCart");
const sendSubscription = fb.default.functions.httpsCallable("sendSubscription");
import Steps from "../components/Steps.vue";
import Info from "../components/Info.vue";
import Superrb from "../components/Superrb.vue";
import CartPopup from "../components/CartPopup";
import axios from "axios";

export default {
  name: "purchase",
  components: {
    steps: Steps,
    info: Info,
    "cart-popup": CartPopup,
    superrb: Superrb
  },
  data() {
    return {
      step: 1,
      steps: ["cart", "info"],
      guards: [],
      popup: false,
      customerSent: false,
      mandrillKey: "Zccmdcv0NA2ICSENzK7WcA",
      mouthguards: [],
      shippingInfo: null,
      billingInfo: null,
      userInfo: null,
      existingCustomer: false,
      payload: null,
      custom_data: null,
      showSuccess: false,
      paymentUrl: "",
      superrb: null,
      subscriptionInfo: null
    };
  },
  created() {
    this.$nextTick(() => {
      this.superrb = this.$route.params.superrb_data;
      delete this.$route.params.superrb_data;
    });
  },
  methods: {
    next(name, data) {
      let vm = this;
      this[name] = data;
      let num = this.step;
      this.step = null;
      setTimeout(function() {
        vm.step = num + 1;
      }, 500);
    },
    jumpTo(i) {
      let vm = this;
      if (this.step > i) {
        vm.step = i;
      }
    },
    assignUserInfo(user, subscription) {
      let vm = this;
      vm.userInfo = user;
      setTimeout(function() {
        if (vm.$route.params.subscription) {
          vm.subscriptionInfo = subscription;
          vm.sendSubscriptionApi();
        } else {
          vm.sendDataApi();
        }
      }, 500);
    },
    async sendDataApi() {
      let data = this.$route.params;
      let payload = {
        product_id: parseInt(data.product_id),
        checkout_in_place: 1,
        quantity: data.quantity,
        name: this.userInfo.firstName + " " + this.userInfo.lastName,
        email: this.userInfo.email,
        phone: this.userInfo.phone,
        notes: this.userInfo.notes,
        design_url: data.design_url,
        texture: data.image_to_print,
        screenshot: data.screenshot,
        has_scan: 1,
        checkout_in_place: true
      };
      console.log(payload);
      let response = await sendCart(payload);
      if (response.data.success) {
        window.open(response.data.redirect_url, "_blank");
        window.close();
      } else {
        alert(
          "Design has saved. But something went wrong. Please try again or contact us at info@mouthguardclub.com"
        );
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style>
.demo {
  max-width: 100%;
}
</style>
